import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HandoverInitiateComponent } from './components/handover-initiate/handover-initiate.component';
import { HandoverDetailComponent } from './components/handover-detail/handover-detail.component';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './shared/auth/auth.guard';
import { ErrorComponent } from './components/shared/error/error.component';
import { CanDeactivateHoDetailGuard } from './components/handover-detail/can-deactivate-ho-detail.guard';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'initiateHandover',
    component: HandoverInitiateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'handover/:id',
    component: HandoverDetailComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateHoDetailGuard],
  },
  { path: 'error', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
